export default __webpack_public_path__ + "static/media/rounded_star.cf1ca931.svg";